import { chunkArr, waitForTruthyVal } from "../helpers/utils";
export function getInStockRecommendations(options, metaOptions = {}) {
    return new Promise((resolve, reject) => {
        if (window.DYO) {
            const rules = getRulesByOptions(options);
            const timeoutID = setTimeout(() => {
                console.error("DYO in-stock recommmendation timeout");
                reject();
            }, window.UNTUCKitConfig.dyTimeout);
            const opts = {
                realtimeRules: rules, ...metaOptions
            };
            window.DYO.recommendationWidgetData(window.UNTUCKitConfig.inStockRecommendationStrategyId, opts, function (error, data) {
                clearTimeout(timeoutID);
                if (error) {
                    console.error(error);
                    reject();
                }
                else {
                    resolve(data);
                }
            });
        }
        else {
            console.warn("Dynamic Yield not available.");
            reject();
        }
    });
}
export function registerRecommendationElement(el) {
    if (window.DYO) {
        window.DYO.recommendations.registerElements(el);
    }
    else {
        console.warn("Dynamic Yield not available.");
    }
}
function getRulesByOptions(options) {
    const rules = [];
    if (options) {
        if (options.size) {
            rules.push(generateRule(1, "size", options.size));
        }
        if (options.fit) {
            rules.push(generateRule(2, "fit", options.fit));
        }
        if (options.vendor) {
            rules.push(generateRule(3, "vendor", options.vendor));
        }
        if (options.gender) {
            rules.push(generateRule(4, "gender", options.gender));
        }
        if (options.sku) {
            rules.push(generateRule(5, "sku", options.sku, "exclude"));
        }
    }
    return rules;
}
function generateRule(id, field, value, queryType = "include") {
    return {
        "id": id,
        "query": {
            "conditions": [{
                    "field": field,
                    "arguments": [{
                            "action": "IS",
                            "value": value
                        }]
                }]
        },
        "type": queryType,
        "slots": []
    };
}
export async function getSocialProof(skus, timespan, interaction) {
    const dyApiLoaded = await waitForTruthyVal(() => window.DY?.API !== undefined);
    if (dyApiLoaded) {
        const chunks = chunkArr(skus, 20);
        const promises = chunks.map((skuChunk) => {
            return new Promise((resolve, reject) => {
                window.DY.API('callback', () => {
                    window.DY.ServerUtil.getProductsData(skuChunk, [timespan], interaction, true, (err, res) => {
                        if (err)
                            reject(err);
                        resolve(res);
                    });
                });
            });
        });
        try {
            const dataArr = await Promise.all(promises);
            const data = dataArr.reduce((curr, acc) => {
                return { ...acc, ...curr };
            }, {});
            return data;
        }
        catch (err) {
            console.error("social proof error", err);
        }
    }
}
